import React from 'react'

import Slideshow from './Slideshow'
import Link from '../components/Link'
import GreetingImage from '../assets/images/home/praise.jpg'


export const WelcomeHeader = ( { className, images, headerTitle, headerText, headerButtons, tint = 0, icon, blur = 0, url='https://www.youtube.com/channel/UCo1-ajfKW62orxAK4TPkQ3Q/live' } ) => {

     
    return (
        <section id="header" className={className}>

            <div>
                { icon && icon }
                <image class='img' src={GreetingImage} width={500} height={500}/>
                { headerTitle ?
                    ( <>
                        <h1 className="header-title">
                            <span className="major" style={{ fontWeight: 600 }}>Welcome to BCB</span>
                        </h1>
                        {/* <hr/> */}
                    </>
                     ) : null
                    
                }



                {/* { headerText ?
                    ( <p className="header-text" dangerouslySetInnerHTML={{ __html: headerText.replace( /\n/g, "<br />" ) }}/> ) : null

                    
                } */}
                <span className='main-header-text'>
                    <h2>
                        Church Service
                    </h2>
                    <h3>
                        Sunday 10:30am - 12:00pm
                    </h3>
                </span>
                <ul className="actions"> 
                    <li key={url}><Link to={'/services#live-sermons'} className="button blue">Watch Here</Link></li>
                </ul>
            </div>
                        <Slideshow images={images} enableTint tint={tint + 0.1} blur={blur} />

        </section>
    )
}

const Header = ( { className, images, headerTitle, headerText, headerButtons, tint = 0, icon, blur = 0 } ) => {

     
    return (
        <section id="header" className={className}>
            <Slideshow images={images} enableTint tint={tint + 0.1} blur={blur} />

            <div className="inner">
                { icon && icon }
                { headerTitle ?
                    ( <>
                        <h1 className="header-title">
                            <span className="major" style={{ fontWeight: 600 }}>{headerTitle}</span>
                        </h1>
                        <hr/>
                    </>
                     ) : null
                    
                }



                { headerText ?
                    ( <p className="header-text" dangerouslySetInnerHTML={{ __html: headerText.replace( /\n/g, "<br />" ) }}/> ) : null

                    
                }
                {/* <ul className="actions"> 
                { headerButtons ?
                    headerButtons.map( ( { url, text } ) => (<li key={url}><AniLink fade to={url} className="button scrolly">{text}</AniLink></li>) ) :
                    (<li><AniLink fade to="#welcome" className="button scrolly">Discover</AniLink></li>)
                }
                </ul> */}
            </div>
        </section>
    )
}

// (<h1>Hi, I'm <strong>Photon</strong>, another fine<br />
//                     little freebie from <a href="http://html5up.net">HTML5 UP</a>.</h1>)

// (<p>Accumsan feugiat mi commodo erat lorem ipsum, sed magna<br />
//     lobortis feugiat sapien sed etiam volutpat accumsan.</p>)
export default Header
